import { BaseActivityEvent } from './BaseActivityEvent'
import { ReactComponent as LayerIcon } from './icons/layers.svg'
import { Actor } from './Actor'
import { ActivityEventPosition, ActivityEventTrackMode, LayerCreatedEvent } from './Types'

interface Props extends ActivityEventPosition {
  event: LayerCreatedEvent
}

const LayerCreated = ({ event, ...props }: Props) => {
  const { user, data, layer } = event

  const isCurrentLayer = data.created_layer_id === layer.id

  const text = isCurrentLayer ? 'created this layer.' : `created a layer called ${data.created_layer_name}`

  return (
    <BaseActivityEvent
      {...props}
      icon={<LayerIcon style={{ color: data.created_layer_color }} />}
      trackMode={ActivityEventTrackMode.Branch}
      timestamp={event.timestamp}
      content={
        <>
          <Actor displayName={user.display_name || 'Anonymous User'} userId={user?.id} /> {text}
        </>
      }
    />
  )
}

export { LayerCreated }
